import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState } from '../../../../store';
import FinancialDocs, { IDispatchProps, IProps } from './index';
import { openFinanceDocumentModal, openUploadFinanceModal } from '../../../../store/ui/actions';
import { approveDoc, acknowledgeDoc } from '../../../../store/student/financeDocuments/actions';
import { hasAnyMatchingFinDocs } from '../../../../utilities/documents';
import { updateRisks } from '../../../../store/student/actions';

const mapStateToProps = (state: ApplicationState): IProps => {
  const { financials, config, financeDocuments } = state.student;
  const { courses } = state.student.offer;

  const hasRequiredDocs = hasAnyMatchingFinDocs(financeDocuments, 'required');
  const hasInfoOnlyDocs = hasAnyMatchingFinDocs(financeDocuments, 'infoOnly');
  const hasStaffOnlyDocs = hasAnyMatchingFinDocs(financeDocuments, 'staffOnly');
  const hasAgentOnlyDocs = hasAnyMatchingFinDocs(financeDocuments, 'agentOnly');

  const totalAmountToProve = financials.fundingSummary?.totalRemaining ?? 0;
  return {
    hasRequiredDocs,
    hasInfoOnlyDocs,
    hasStaffOnlyDocs,
    hasAgentOnlyDocs,
    documents: financeDocuments,
    userRole: state.auth.role,
    personalInfo: state.student.personalInfo!,
    history: state.student.history!,
    openModal: state.ui.openModal,
    financials: state.student.financials!,
    risks: state.student.risks!,
    courses,
    config,
    // isCourseSelected: courseName !== '',
    totalAmountToProve,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onUpdateRisks: (source: string, clearedRisks: any) => dispatch(updateRisks({ source, clearedRisks })),
  openFinanceDocumentModal: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle?: string,
  ) => {
    dispatch(openFinanceDocumentModal(sponsorType, sponsorKey, docType, docKey, modalTitle));
  },
  openUploadFinanceModal: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle: string,
    fileNames: string[],
    metadata?: any,
  ) => {
    dispatch(openUploadFinanceModal(sponsorType, sponsorKey, docType, docKey, modalTitle, fileNames, metadata));
  },
  onApproveDoc: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    docStatus?: string,
    docPrevStatus?: string,
  ) => {
    dispatch(approveDoc(sponsorType, sponsorKey, docType, docKey, docStatus, docPrevStatus));
  },
  onAcknowledgeDoc: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    docStatus?: string,
    docPrevStatus?: string,
  ) => {
    dispatch(acknowledgeDoc(sponsorType, sponsorKey, docType, docKey, docStatus, docPrevStatus));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FinancialDocs);
